import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { Module } from '../module.model';
import { ModuleActions, ModuleActionTypes } from '../actions/module.actions';
import {EventsState} from '../../../store/reducers/events.reducers';

export interface ModuleState extends EntityState<Module> {
  Loaded: boolean;
  Loading: boolean;
}

export const adapter: EntityAdapter<Module> = createEntityAdapter<Module>({
  selectId: module => module.Id,
  sortComparer: sortBySeqNo
});

export const initialState: ModuleState = adapter.getInitialState({
  Loaded: false,
  Loading: false
});

export function sortBySeqNo(a: Module, b: Module) {
  return a.Sort - b.Sort;
}

export function reducer(
  state = initialState,
  action: ModuleActions
): ModuleState {
  switch (action.type) {
    case ModuleActionTypes.GetModules: {
      return {...state, Loaded: false, Loading: true};
    }

    case ModuleActionTypes.GetModulesByRegion: {
      return {...state, Loaded: false, Loading: true};
    }

    case ModuleActionTypes.AddModule: {
      return adapter.addOne(action.payload.module, state);
    }

    case ModuleActionTypes.UpsertModule: {
      return adapter.upsertOne(action.payload.module, state);
    }

    case ModuleActionTypes.AddModules: {
      return adapter.addMany(action.payload.modules, state);
    }

    case ModuleActionTypes.UpsertModules: {
      return adapter.upsertMany(action.payload.modules, state);
    }

    case ModuleActionTypes.UpdateModule: {
      return adapter.updateOne(action.payload.module, state);
    }

    case ModuleActionTypes.UpdateModules: {
      return adapter.updateMany(action.payload.modules, state);
    }

    case ModuleActionTypes.DeleteModule: {
      return adapter.removeOne(action.payload.id, state);
    }

    case ModuleActionTypes.DeleteModules: {
      return adapter.removeMany(action.payload.ids, state);
    }

    case ModuleActionTypes.LoadModules: {
      return adapter.setAll(action.payload.modules, {
        ...state,
        Loaded: true,
        Loading: false
      });
    }

    case ModuleActionTypes.ClearModules: {
      return adapter.removeAll(state);
    }

    default: {
      return state;
    }
  }
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();

// select the array of users
export const selectAllModules = selectTotal;
export const getModules = (state: ModuleState) => state;
